import React from "react"
import Header from "./components/Header"
import Meme from "./components/Meme"
// import travelList from "./data"

export default function App(){
    return (
        <div>
            <Header />
            <Meme />
        </div>
    )
}

